/**
 * 定数管理
 */

// カートのステッパー
export const FRONT_STORE_CART_STEPPER = 'frontCartStepper'
